<mat-form-field
  appearance="outline"
  [ngClass]="{ 'mat-form-field-invalid': ngControl.invalid && ngControl.touched, 'dense-input': dense }">
  <mat-label>
    <span i18n>Телефон</span>
    {{ requiredd ? '*' : '' }}
  </mat-label>

  <mat-select
    class="w-20"
    [ngModel]="selectedCountry"
    name="phoneCodeSelect"
    [disabled]="disabled"
    (selectionChange)="onCountrySelect($event.value, focusable)">
    <mat-select-trigger>
      <div class="flex items-center gap-2">
        <div class="iti-flag" [ngClass]="selectedCountry?.flagClass"></div>
        <div *ngIf="separateDialCode" class="selected-dial-code">+{{ selectedCountry.dialCode }}</div>
      </div>
    </mat-select-trigger>

    <mat-option *ngFor="let country of preferredCountriesInDropDown" [value]="country">
      <div class="flex items-center gap-2">
        <div class="iti-flag" [ngClass]="country.flagClass"></div>

        <div class="country-name">{{ country.name }}</div>
        <div class="dial-code secondary-text">+{{ country.dialCode }}</div>
      </div>
    </mat-option>

    <mat-option class="h-2" disabled *ngIf="preferredCountriesInDropDown?.length">
      <mat-divider> </mat-divider>
    </mat-option>

    <mat-option *ngFor="let country of allCountries" [value]="country">
      <div class="flex items-center gap-2">
        <div class="iti-flag" [ngClass]="country.flagClass"></div>
        <span class="country-name">{{ country.name }}</span>
        <span class="dial-code secondary-text">+{{ country.dialCode }}</span>
      </div>
    </mat-option>
  </mat-select>

  <mat-divider class="divider" [vertical]="true"> </mat-divider>

  <input
    matInput
    type="tel"
    (click)="$event.stopPropagation(); $event.preventDefault()"
    [id]="inputId"
    autocomplete="off"
    [ngClass]="cssClass"
    (blur)="onTouched()"
    (keypress)="onInputKeyPress($event)"
    [(ngModel)]="phoneNumber"
    (ngModelChange)="onPhoneNumberChange()"
    [disabled]="disabled"
    [placeholder]="resolvePlaceholder()"
    [attr.maxLength]="maxLength"
    #focusable />
</mat-form-field>

<!-- {{ ngControl.errors | json }} -->
